/**
 * Created by Ning Jiang on 10/24/2018.
 */

import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {ReelSymbolStateCreator} from "@nolimitcity/slot-game/bin/core/reelsymbol/ReelSymbolStateCreator";
import {ISymbolStateConfig, StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {RomanEmpireGameConfig} from "../RomanEmpireGameConfig";
import {WalkingWild} from "../walkingwild/WalkingWild";

export class RomanEmpireReelSymbolStateCreator extends ReelSymbolStateCreator {

    constructor() {
        super();
    }

    protected noWinStateCreator(symbol: StateReelSymbol, stateKey: string, stateConfig: ISymbolStateConfig): TimelineSprite | null {
        const stateAnimation: TimelineSprite | null = this.getBasicStateAnimation(symbol, stateKey, stateConfig);
        if (stateAnimation) {
            stateAnimation.tint = 0x555555;
        }
        return stateAnimation;
    }

    protected getBasicStateAnimation(symbol: StateReelSymbol, stateKey: string, stateConfig: ISymbolStateConfig): TimelineSprite | null {
        const symName: string = symbol.symName.split("*")[0];

        if (RomanEmpireGameConfig.instance.SYMBOLS_WITH_WIN_SPINE.indexOf(symName) !== -1) {
            if (stateKey === RomanEmpireGameConfig.instance.SYMBOL_STATES.initialWin.keyword) {
                const spineTextures: PIXI.spine.core.SkeletonData = GameResources.getSpineAsset(symName);
                const spine: PIXI.spine.Spine = new PIXI.spine.Spine(spineTextures);
                // this.setSymbolPos(spine, symName);
                return (spine as any);
            }

            if (stateKey === RomanEmpireGameConfig.instance.SYMBOL_STATES.normal.keyword) {
                const spineTextures: PIXI.spine.core.SkeletonData = GameResources.getSpineAsset(symName);
                const spine: PIXI.spine.Spine = new PIXI.spine.Spine(spineTextures);
                spine.state.setAnimation(0, symName.toLocaleLowerCase() + "_normal", false);
                return (spine as any);
            }
        }

        const spriteTl = super.getBasicStateAnimation(symbol, stateKey, stateConfig);
        if (stateKey == RomanEmpireGameConfig.instance.SYMBOL_STATES.spin.keyword && spriteTl && (WalkingWild.IS_FINAL_MULTIPLIER_MOVING || WalkingWild.IS_HANDOVER)) {
            spriteTl.tint = 0x555555;
        }
        return spriteTl;
    }

}